"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../../theme");

var _basis = require("basis");

var _ = require("./..");

var _getValidation = require("../../utils/getValidation");

var _Captcha = require("./Captcha");

var _TextContent = require("../text-content/TextContent");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getVariant = function getVariant(keyboardType) {
  switch (keyboardType) {
    case 'number':
      return 'text';

    default:
      return 'text';
  }
};

var getOptions = function getOptions(values) {
  if (!values) {
    return [];
  }

  return Object.entries(values).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        value = _ref2[0],
        label = _ref2[1];

    return {
      label: String(label),
      value: value
    };
  });
};

var FieldList = function FieldList(props) {
  var theme = (0, _theme.useTheme)();
  var credentials = props.credentials;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, credentials.map(function (credential) {
    var fieldID = credential.fieldID,
        name = credential.name,
        keyboardType = credential.keyboardType,
        optional = credential.optional,
        description = credential.description;
    var type = credential.type.toLowerCase();
    var validation = (0, _getValidation.getValidation)(_objectSpread(_objectSpread({}, credential.validation), {}, {
      optional: optional
    }));

    switch (type) {
      case 'text':
        return /*#__PURE__*/_react.default.createElement(_basis.Input, {
          key: fieldID,
          name: fieldID,
          testId: fieldID,
          label: name,
          variant: getVariant(keyboardType),
          optional: optional,
          helpText: description,
          validate: validation,
          color: theme.inputColor
        });

      case 'password':
        return /*#__PURE__*/_react.default.createElement(_basis.Input, {
          key: fieldID,
          name: fieldID,
          testId: fieldID,
          label: name,
          type: "password",
          optional: optional,
          helpText: description,
          validate: validation,
          color: theme.inputColor
        });

      case 'select':
        var _ref3 = credential,
            _values = _ref3.values;
        return /*#__PURE__*/_react.default.createElement(_basis.Select, {
          key: fieldID,
          name: fieldID,
          testId: fieldID,
          label: name,
          placeholder: "Please select",
          options: getOptions(_values),
          optional: optional,
          helpText: description,
          validate: validation,
          color: theme.inputColor
        });

      case 'captcha':
        return /*#__PURE__*/_react.default.createElement(_Captcha.Captcha, {
          key: fieldID,
          credentials: credential,
          validation: validation,
          inputColor: theme.inputColor
        });

      default:
        return null;
    }
  }));
};

var LoginForm = function LoginForm(props) {
  var buttonSubmitLabel = (0, _TextContent.useTextContent)('login.buttonSubmit');
  var urlUserTermsAndConditions = (0, _TextContent.useTextContent)('login.urlUserTermsAndConditions');
  var urlPrivacyPolicy = (0, _TextContent.useTextContent)('login.urlPrivacyPolicy');
  var urlEncryptionInformation = (0, _TextContent.useTextContent)('login.urlEncryptionInformation');
  var textAnd = (0, _TextContent.useTextContent)('login.textAnd');
  var initialValues = props.initialValues,
      credentials = props.credentials,
      loading = props.loading,
      onSubmit = props.onSubmit,
      onGoBack = props.onGoBack;

  var handleSubmit = function handleSubmit(state) {
    !Object.keys(state.errors).length && onSubmit(state.values);
  };

  return /*#__PURE__*/_react.default.createElement(_.Form, {
    id: "login",
    initialValues: initialValues,
    onSubmit: loading ? function () {} : handleSubmit
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_.FormLayout, null, /*#__PURE__*/_react.default.createElement(FieldList, {
      credentials: credentials
    }), /*#__PURE__*/_react.default.createElement(_basis.Text, {
      textStyle: "legal"
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.textTermsAndConditions",
      vars: {
        buttonSubmit: buttonSubmitLabel
      }
    }), /*#__PURE__*/_react.default.createElement(_basis.Link, {
      href: urlUserTermsAndConditions,
      newTab: true
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.linkTermsAndConditions"
    })), " ".concat(textAnd, " "), /*#__PURE__*/_react.default.createElement(_basis.Link, {
      href: urlPrivacyPolicy,
      newTab: true
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.linkPrivacyPolicy"
    }))), /*#__PURE__*/_react.default.createElement(_.FormButtonsLayout, null, /*#__PURE__*/_react.default.createElement(_.SubmitButton, {
      loading: loading
    }, buttonSubmitLabel), /*#__PURE__*/_react.default.createElement(_basis.Button, {
      variant: "secondary",
      onClick: onGoBack
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.buttonBack"
    }))), /*#__PURE__*/_react.default.createElement(_basis.Text, {
      textStyle: "legal"
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.textDisclaimer"
    }), " ", /*#__PURE__*/_react.default.createElement(_basis.Link, {
      href: urlEncryptionInformation,
      newTab: true
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "login.linkEncryptionInformation"
    }))));
  });
};

exports.LoginForm = LoginForm;